import React, { useRef, useEffect } from 'react';

interface Props {
    cxRedirectUrl: string;
    setShowIframe: (value: boolean) => void;
    classes?: any;
}
const FlexRegIframe = ({ cxRedirectUrl, setShowIframe, classes }: Props) => {
  const iframeRef = useRef(null);

    useEffect(() => {
      window.addEventListener('message', checkForMessage);
      return () => {
        window.removeEventListener('message', checkForMessage);
      };
    }, []);
  
    const checkForMessage = (event: any) => {
      if (event.data?.type === 'appily_tab_closed') {
        window.parent.postMessage({ message: ':::personalization' }, '*');
        window.parent.postMessage(
          { message: 'RegistrationForm_Completed', millisecondsUntilClose: 200 },
          '*'
        );
      }
    };

  return (
     <div className={classes.appilyIframeContainer}>
          <iframe 
            ref={iframeRef}
            src={cxRedirectUrl}
            width="100%"
            height="100%"
            title="Appily"
          />
    </div>
  );
};

export default FlexRegIframe;try {
    // @ts-ignore
    FlexRegIframe.displayName = "FlexRegIframe";
    // @ts-ignore
    FlexRegIframe.__docgenInfo = { "description": "", "displayName": "FlexRegIframe", "props": { "cxRedirectUrl": { "defaultValue": null, "description": "", "name": "cxRedirectUrl", "required": true, "type": { "name": "string" } }, "setShowIframe": { "defaultValue": null, "description": "", "name": "setShowIframe", "required": true, "type": { "name": "(value: boolean) => void" } }, "classes": { "defaultValue": null, "description": "", "name": "classes", "required": false, "type": { "name": "any" } } } };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined")
        // @ts-ignore
        STORYBOOK_REACT_CLASSES["src/components/appilyAuth/FlexRegIframe.tsx#FlexRegIframe"] = { docgenInfo: FlexRegIframe.__docgenInfo, name: "FlexRegIframe", path: "src/components/appilyAuth/FlexRegIframe.tsx#FlexRegIframe" };
}
catch (__react_docgen_typescript_loader_error) { }